<template>
  <AppLoadingScreen v-if="isResolvingInitialRoute" />
  <a-config-provider v-else :theme="ANT_DESIGN_THEME">
    <router-view />
    <AuthSessionSync />
  </a-config-provider>

  <DynamicImportFailureModal />

  <DevCommandPalette v-if="VITE_APP_DEMO_MENU_ACTIVE" />
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ANT_DESIGN_THEME } from '@/utilities/ant-design'
import { usePostHog } from '@/composables/posthog'

import DevCommandPalette from '@/components/DevCommandPalette.vue'
import AppLoadingScreen from '@/components/AppLoadingScreen.vue'
import DynamicImportFailureModal from '@/components/Modals/DynamicImportFailureModal.vue'
import { isResolvingInitialRoute } from '@/router/router'
import AuthSessionSync from '@/components/Modals/AuthSessionSync.vue'

const VITE_APP_DEMO_MENU_ACTIVE =
  import.meta.env.VITE_APP_DEMO_MENU_ACTIVE === 'true' ? true : false

const router = useRouter()
const { posthog, hasInitialised, initPosthog } = usePostHog()

if (!hasInitialised.value) {
  initPosthog()
}

router.beforeEach((to, from) => {
  if (from.path !== to.path && hasInitialised.value) {
    posthog?.capture('$pageleave')
  }
})

router.afterEach(() => {
  if (hasInitialised.value) {
    posthog?.capture('$pageview')
  }
})
</script>

<style lang="scss">
@use 'sass:map';
@use '@/styles/variables';
@use '@/styles/theme';
</style>
